<template>
    <div class="brandInviteWrap">
        <div class="topSection">
            <div class="formWrap">
                <div class="left">
                    <div class="label">* 请先选择主动邀约公司：</div>
                    <div>
                        <el-select placeholder="请选择公司" v-model="selectCompanyId" style="width: 300px;">
                            <el-option :label="list.text" :value="list.value"    v-for="(list,index) in companyWord" :key="index"></el-option>
                        </el-select>
                    </div>
                    
                </div>
                <div class="right">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
                       
                      <el-form-item label="被邀约公司" prop="inviteCompanyName" required>
                        <el-input v-model="ruleForm.inviteCompanyName" placeholder="请输入对方公司名称"></el-input>
                      </el-form-item>
                      <el-form-item label="被邀约品牌" prop="inviteBrandName" required>
                        <el-input v-model="ruleForm.inviteBrandName" placeholder="请输入对方公司服装品牌名称"></el-input>
                      </el-form-item>
                      <el-form-item label="被邀约联系人" prop="inviteRealname" required>
                        <el-input v-model="ruleForm.inviteRealname" placeholder="请输入对方公司负责人姓名"></el-input>
                      </el-form-item>
                      <el-form-item label="被邀约联系手机号" prop="inviteCellphone" required>
                        <el-input v-model="ruleForm.inviteCellphone" placeholder="请输入对方注册衣加加的手机号"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">确认提交</el-button>
                      </el-form-item>
                    </el-form>
                </div>
                
                
            </div>
        </div>
        
        <!-- <div class="panelTitle">该公司所有邀约信息：    </div> -->
        <div class="tabBox">
            <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
                <el-tab-pane label="全部" name="all">
                    <div class="listDetailWrap">
                        <p style="text-align: center;color:#999" v-if="tableLists&&tableLists.length==0">暂无列表</p>
                        <div v-for="(list,index) in tableLists" :key="index" class="listWrap">
                            <p> 
                                <span style="font-weight: bold;">{{index+1}}.</span>
                                <span v-if="list.invite_state=='y'" class="green">同意邀约</span>
                                <span v-if="list.invite_state=='n'" class="red">拒绝邀约</span>
                                <span v-if="list.invite_state=='p'" class="orange_lighter">等待确认中</span>
                             </p>
                            <p>被邀约公司名称：{{list.invite_company_name}}</p>
                            <p>被邀约品牌名称：{{list.invite_brand_name}}</p>
                            <p>被邀约联系人姓名：{{list.invite_realname}}</p>
                            <p>被邀约手机号（对方注册衣加加手机号）：{{list.invite_cellphone}}</p>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="已通过" name="y">
                    <div class="listDetailWrap">
                        <p style="text-align: center;color:#999" v-if="tableLists&&tableLists.length==0">暂无列表</p>
                        <div v-for="(list,index) in tableLists" :key="index" class="listWrap">
                            <p> 
                                <span style="font-weight: bold;">{{index+1}}.</span>
                                <span v-if="list.invite_state=='y'" class="green">同意邀约</span>
                                <span v-if="list.invite_state=='n'" class="red">拒绝邀约</span>
                                <span v-if="list.invite_state=='p'" class="orange_lighter">等待确认中</span>
                             </p>
                            <p>被邀约公司名称：{{list.invite_company_name}}</p>
                            <p>被邀约品牌名称：{{list.invite_brand_name}}</p>
                            <p>被邀约联系人姓名：{{list.invite_realname}}</p>
                            <p>被邀约手机号（对方注册衣加加手机号）：{{list.invite_cellphone}}</p>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="未通过" name="n">
                    <div class="listDetailWrap">
                        <p style="text-align: center;color:#999" v-if="tableLists&&tableLists.length==0">暂无列表</p>
                        <div v-for="(list,index) in tableLists" :key="index" class="listWrap">
                            <p> 
                                <span style="font-weight: bold;">{{index+1}}.</span>
                                <span v-if="list.invite_state=='y'" class="green">同意邀约</span>
                                <span v-if="list.invite_state=='n'" class="red">拒绝邀约</span>
                                <span v-if="list.invite_state=='p'" class="orange_lighter">等待确认中</span>
                             </p>
                            <p>被邀约公司名称：{{list.invite_company_name}}</p>
                            <p>被邀约品牌名称：{{list.invite_brand_name}}</p>
                            <p>被邀约联系人姓名：{{list.invite_realname}}</p>
                            <p>被邀约手机号（对方注册衣加加手机号）：{{list.invite_cellphone}}</p>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="等待中" name="p">
                    <div class="listDetailWrap">
                        <p style="text-align: center;color:#999" v-if="tableLists&&tableLists.length==0">暂无列表</p>
                        <div v-for="(list,index) in tableLists" :key="index" class="listWrap">
                            <p> 
                                <span style="font-weight: bold;">{{index+1}}.</span>
                                <span v-if="list.invite_state=='y'" class="green">同意邀约</span>
                                <span v-if="list.invite_state=='n'" class="red">拒绝邀约</span>
                                <span v-if="list.invite_state=='p'" class="orange_lighter">等待确认中</span>
                             </p>
                            <p>被邀约公司名称：{{list.invite_company_name}}</p>
                            <p>被邀约品牌名称：{{list.invite_brand_name}}</p>
                            <p>被邀约联系人姓名：{{list.invite_realname}}</p>
                            <p>被邀约手机号（对方注册衣加加手机号）：{{list.invite_cellphone}}</p>
                        </div>
                    </div>
                </el-tab-pane>
              </el-tabs>
        </div>
        
    </div>
</template>

<script>
    import {        json,        wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,        api    } from '@/common/request.js'
    export default {
        name: 'adminIndex',
        data() {
            return {
                conferenceId:'',
                companyWord:[],
                selectCompanyId:'',
                ruleForm:{
                    "inviteCellphone":"",
                    // "conferenceId":"44",
                    "inviteCompanyName":"",
                    "inviteBrandName":"",
                    "inviteRealname":""
                },
                rules:{},
                activeName: '',
                tableLists:[],
                currentTab:'',
            }
        },
        computed: {
        },
        methods: {
            handleClick(tab, event) {
                let state=''
                if(tab.name=='all'){
                    state=''
                }else{
                    state=tab.name
                }
                this.currentTab=state
                this.getDetail()
              },
            refreshPage(){
                this.resetForm('ruleForm')
                this.getDetail()
            },
            submitForm(formName) {
                let _this=this
                this.$refs[formName].validate((valid) => {
                  if (valid) {
                      let arg={}
                      arg=JSON.parse(JSON.stringify(_this.ruleForm))  
                      arg.conferenceId=_this.conferenceId
                      arg.invitePartnerId=_this.selectCompanyId
                      console.log(arg)
                      ajaxPost('/admin/addpartnerinvite', arg).then(function(res) {
                          if(res.errorCode==200){
                              alert("邀请成功")
                              _this.refreshPage()
                          }
                      }, function(res) {
                      
                      })
                      
                  } else {
                    console.log('error submit!!');
                    return false;
                  }
                });
              },
              resetForm(formName) {
                this.$refs[formName].resetFields();
              },
            getCompanyOption(){
                let _this=this
                let arg={
                    conferenceId:_this.conferenceId,
                }
                ajaxPost('/admin/companylist', arg).then(function(res) {
                    if(res.errorCode==200){
                        let resData=res.data?res.data:[]
                        _this.companyWord=resData.map(function(item,index){
                            let buffer={
                                text:item.companyName,
                                value:item.userId,
                            }
                            return buffer
                        })
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
                console.log(this.$route.params)
            },
            getDetail() {
                let _this = this
                let args = {
                    "conferenceId":_this.conferenceId,
                    "invitePartnerId":_this.selectCompanyId,
                    "inviteState":_this.currentTab
                }
                if(args.invitePartnerId&&args.invitePartnerId){
                    ajaxPost('/admin/showpartnerinvite', args).then(function(res) {
                        if (res.data) {
                            _this.tableLists=res.data
                        }
                    }, function(res) {
                    })
                }else{
                    _this.$message("先选择公司")
                }
                
            },

        },
        mounted() {
            let _this = this
            this.getParams()
            this.getCompanyOption()
        },
    }
</script>

<style scoped lang="scss">
    .brandInviteWrap{
        padding:10px;
        .topSection{padding:0 20px;}
        .formWrap{
            padding:10px ;  display: flex;  background: #fff;
            .left{width: 300px; padding:10px;
                .label{font-size: 20px;font-weight: bold;padding:20px 0px;color:red;}
            }
            .right{flex:1;}
        }
        .listDetailWrap{
            padding:10px;background: #fff;
            .listWrap{
                padding:10px;border: 1px dotted #aaa; display: inline-block; margin-right:5px;margin-bottom: 5px;
            }
        }
        .tabBox{padding:0 20px ;}
        .panelTitle{padding-left:20px;padding-top:10px;}

    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/brandInvite.vue